class CommonFunctionService {
  formatDateShow(date) {
    const getDay = String(date.getDate())
    const day = getDay.padStart(2, '0')
    const getMonth = String(date.getMonth() + 1)
    const month = getMonth.padStart(2, '0')
    const year = String(date.getFullYear())
    return `${day}/${month}/${year}`
  }


  formatDateShowWithTime(date) {
    const getDay = String(date.getDate())
    const day = getDay.padStart(2, '0')
    const getMonth = String(date.getMonth() + 1) 
    const month = getMonth.padStart(2, '0')
    const year = String(date.getFullYear())
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    return `${day}/${month}/${year} ${hours}:${minutes}`
  }
}

export default new CommonFunctionService();
